const utils = require('od-modules/xsell/utils');

function buyer(buyer) {
    const self = {};

    self.getAddress = function() {
        return buyer.address;
    };

    self.getCountryCode = function() {
        return buyer.country;
    };

    self.getZipCode = function() {
        return buyer.zipCode;
    };

    self.getAge = function() {
        const birthDateInMillis = Odigeo._.get(buyer, 'dateOfBirth', 0);
        return utils.getAge(birthDateInMillis);
    };

    self.getMail = function() {
        return buyer.mail;
    };
    return self;
}

module.exports = buyer;
